import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';
import { setMappings } from '../../store/Reducers/NavigationAuditRegexSlice';
import { NavigationAuditRegexService } from '../../api/services/navigationAuditRegexService';
import { NavigationAuditRegexDatagrid } from '../../components/DataGrid/NavigationAuditRegex/NavigationAuditRegexDatagrid';

export const NavigationAuditRegexPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const load = async () => {
      try {
        const data = await NavigationAuditRegexService.getAll();
        dispatch(setMappings(data));
      } catch (e: any) {
        dispatch(
          showNotification({
            message: `Failed to load regex mappings. ${e?.response?.data?.message || ''}`,
            severity: 'error',
          }),
        );
      }
    };
    load();
  }, [dispatch]);

  return <NavigationAuditRegexDatagrid />;
};
